import styledsc from "styled-components";
import styled from "@mui/material/styles/styled";
import { StepConnector } from "@mui/material";
import { stepConnectorClasses } from "@mui/material";

export const MainContainer = styledsc.div`
    display: flex;
    justify-content: center;

  .buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;


export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor: "var(--pink-contentoh)",
      borderRadius: 1,
    },
  }));
  
  export const ColorlibStepIconRoot = styled("div")(({ ownerState }) => ({
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      backgroundImage:
        "linear-gradient(180deg, #e33aa9 0%, #3b1366 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    }),
    ...(ownerState.completed && {
      backgroundImage:
        "linear-gradient(180deg, #e33aa9 0%, #3b1366 100%)",
    }),
  }));
  